import React, { useState, useRef } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import {
  INPUT_CHARACTERS_LIMIT,
  MESSAGE_CHARACTERS_LIMIT,
  VALIDATION_MESSAGES,
} from "../constants";
import { useDispatch } from "react-redux";
import { emailContactAction } from "../redux/actions/loginImport";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import greenGrass from "../assets/images/stadium-background.webp";

export default function ContactPage() {
  const [contactDetails, setContactDetails] = useState({
    fullName: "",
    email: "",
    contactType: "",
    message: "",
    company: "",
  });
  const [contactValidationDetails, setContactValidationDetails] = useState({
    fullName: {
      isError: false,
      message: "",
    },
    email: {
      isError: false,
      message: "",
    },
    contactType: {
      isError: false,
      message: "",
    },
    message: {
      isError: false,
      message: "",
    },
    company: {
      isError: false,
      message: "",
    }
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [contactSubmission, setContactSubmission] = useState(
    localStorage.getItem("submitContact")
  );

  const dispatch = useDispatch();
  const emailValidationTimeoutRef = useRef(null); // Ref to store the timeout ID


  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function onContactDetailsChange(event) {
    const name = event.target.name;
    const value = event.target.value;

    let tempContactDetails = contactDetails;

    setContactDetails({ ...contactDetails, [name]: value });
    tempContactDetails[name] = value;

    const sanitizedValue = value.trim();

    if (name === "message") {
      if (sanitizedValue.length > MESSAGE_CHARACTERS_LIMIT) {
        setContactValidationDetails({
          ...contactValidationDetails,
          [name]: {
            isError: true,
            message: VALIDATION_MESSAGES.CHARACTER_LIMIT(
              MESSAGE_CHARACTERS_LIMIT
            ),
          },
        });
      } else {
        setContactValidationDetails({
          ...contactValidationDetails,
          [name]: {
            isError: false,
            message: "",
          },
        });
      }
      return;
    }

    if (name === "email") {
      // Clear any existing timeout to reset the debounce timer
      if (emailValidationTimeoutRef.current) {
        clearTimeout(emailValidationTimeoutRef.current);
      }

      // Set a new timeout to validate the email after 1 second of inactivity
      emailValidationTimeoutRef.current = setTimeout(() => {
        if (!validateEmail(sanitizedValue)) {
          setContactValidationDetails({
            ...contactValidationDetails,
            [name]: {
              isError: true,
              message: "Please enter a valid email address.",
            },
          });
        } else {
          setContactValidationDetails({
            ...contactValidationDetails,
            [name]: { isError: false, message: "" },
          });
        }
      }, 1000);
      return;
    }

    if (sanitizedValue.length > INPUT_CHARACTERS_LIMIT) {
      setContactValidationDetails({
        ...contactValidationDetails,
        [name]: {
          isError: true,
          message: VALIDATION_MESSAGES.CHARACTER_LIMIT(),
        },
      });
    } else {
      setContactValidationDetails({
        ...contactValidationDetails,
        [name]: { isError: false, message: "" },
      });
    }
  }

  const handleScrollTo = (targetId) => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  function onSubmit() {
    const sanitizedEmail = contactDetails.email.trim();
    const sanitizedFullName = contactDetails.fullName.trim();
    const sanitizedContactType = contactDetails.contactType.trim();
    const sanitizedMessage = contactDetails.message.trim();
    const sanitizedCompany = contactDetails.company.trim();

    setContactDetails({
      fullName: sanitizedFullName,
      email: sanitizedEmail,
      contactType: sanitizedContactType,
      message: sanitizedMessage,
      company: sanitizedCompany,
    });
    setContactValidationDetails({
      fullName: {
        isError: !Boolean(sanitizedFullName),
        message: Boolean(sanitizedFullName) ? "" : "Please enter full name.",
      },
      email: {
        isError: !validateEmail(sanitizedEmail),
        message: validateEmail(sanitizedEmail) ? "" : "Please enter a valid email address.",
      },
      contactType: {
        isError: !Boolean(sanitizedContactType),
        message: Boolean(sanitizedContactType) ? "" : "Please choose a contact type.",
      },
      message: {
        isError: !Boolean(sanitizedMessage),
        message: Boolean(sanitizedMessage) ? "" : "Please write your message.",
      },
      company: {
        isError: !Boolean(sanitizedMessage),
        message: Boolean(sanitizedMessage) ? "" : "Please enter your company or organization name.",
      }
    });

    if (!sanitizedFullName || !validateEmail(sanitizedEmail) || !sanitizedContactType || !sanitizedMessage) {
      return;
    }

    dispatch(emailContactAction({ contactDetails }));
    setContactSubmission("true");
  }

  return (
    <>
      <Box sx={{ minHeight: "calc(100lvh - 64px)" }}>
        {contactSubmission ? (
          <>
            {/* <Box
              sx={{
                height: "40vh",
                background: `URL(${greenGrass}) center center/cover no-repeat`,
                minWidth: "calc(100vw - 33px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "55px",
              }}
            >
              <Typography
                sx={{
                  color: "var(--color-white)",
                  fontSize: { xs: "3.2rem", lg: "5rem" },
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "800",
                  lineHeight: "150%",
                  letterSpacing: "-1.52px",
                }}
                variant="h1"
              >
                CONTACT US
              </Typography>
            </Box> */}
            <Typography
              sx={{
                color: "var(--color-black)",
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "800",
                lineHeight: "150%",
                fontSize: "48px",
                letterSpacing: "-0.87px",
                marginBottom: "28px",
                textAlign: "center",
              }}
              variant="h2"
            >
              Thank You for Reaching Out
            </Typography>
            <Typography>
              Thank you for your message.
              <br /> You will be hearing from The Pool Party team in the very
              near future.
            </Typography>
            <Button
              variant="contained"
              sx={{ width: "20%", minWidth: "155px", mt: 3, whiteSpace: "nowrap" }}
              href="/"
            >
              Pool Party Home
            </Button>
          </>
        ) : (
          <>
            {/* <Box
              sx={{
                height: "40vh",
                background: `URL(${greenGrass}) center center/cover no-repeat`,
                minWidth: "calc(100vw - 33px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  color: "var(--color-white)",
                  fontSize: { xs: "3.2rem", lg: "5rem" },
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "800",
                  lineHeight: "150%",
                  letterSpacing: "-1.52px",
                }}
                variant="h1"
              >
                CONTACT US
              </Typography>
            </Box> */}

            <Box
              sx={{
                width: { xs: "100%", lg: "100%" },
                margin: "auto",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                // px: 3,
              }}
            >
              <Typography
                sx={{
                  color: "var(--color-black)",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "800",
                  fontSize:"58px",
                  lineHeight: isMobile? "1.2" : "150%",
                  letterSpacing: "-0.87px",
                  textAlign: isMobile? "left" : "center",
                  width: isMobile? "300px" : "unset",
                  margin: isMobile? "32px auto 0 auto" : "auto",
                }}
                variant="h1"
              >
                Become a Partner
              </Typography>
              <Typography
                sx={{
                  color: "var(--color-text)",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "16px",
                  lineHeight: isMobile? "1.4" : "170%",
                  letterSpacing: "-0.266px",
                  maxWidth: isMobile? '300px': "822px",
                  margin: "0 auto",
                  textAlign: isMobile? "left" : "center",
                }}
                variant="body1"
              >
             For many, sports aren't just a pastime, they are part of our history, and a way of life.<br /><br />
             At Pool Party Gaming, we take that passion to the next level by hosting personalized sports pools that engage fans, drive excitement, and create opportunities for businesses like yours to be part of the action.
              </Typography>

              <img style={{display:'block', width:'100%', maxWidth: isMobile? '250px' : '450px', margin:'0 auto'}} src="https://poolpartyfilestorage.blob.core.windows.net/media/poolPartyGrayscale.png" alt="Pool Party Gray Scale Logo" />
              <Box
              sx={{display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: 2,
                mt: 3,
              }}>
                <Box>
                  <Typography
                    sx={{
                      color: "var(--color-black)",
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "18px",
                      lineHeight: "150%",
                      letterSpacing: "-0.266px",
                    }}>
                      Business
                    </Typography>
                </Box>
                <Box>
                    <Typography
                    sx={{
                      color: "var(--color-black)",
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "18px",
                      lineHeight: "150%",
                      letterSpacing: "-0.266px",
                    }}>
                      Industry
                    </Typography>
                </Box>
                <Box>
                    <Typography
                    sx={{
                      color: "var(--color-black)",
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "18px",
                      lineHeight: "150%",
                      letterSpacing: "-0.266px",
                    }}>
                      Fundraiser
                    </Typography>
                </Box>
                <Box>
                    <Typography
                    sx={{
                      color: "var(--color-black)",
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "18px",
                      lineHeight: "150%",
                      letterSpacing: "-0.266px",
                    }}>
                      Creator
                    </Typography>
                </Box>
              </Box>
              <Box sx={{
                display: isMobile? 'block': 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start', // Align items to the start of the flex container
                gap: 5, // Add some space between the boxes
              }}>
                <Box sx={{
                  maxWidth: isMobile? "300px" : "375px",
                  margin: isMobile? "16px auto" : "unset"
                }}>
                  <Typography
                    sx={{
                      color: "var(--color-black)",
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "18px",
                      lineHeight: "150%",
                      letterSpacing: "-0.266px",
                      textAlign: "left", // Ensure the text is aligned to the left
                    }}>
                      Why join our winning team?
                    </Typography>
                    <Typography sx={{
                      textAlign: "left", // Ensure the text is aligned to the left
                      lineHeight: "150%",
                      fontSize: "16px", // Ensure the font size is consistent
                    }}>
                    We believe teamwork extends beyond the playing field—it's the cornerstone of success. By partnering with us, you join a dynamic network of innovative businesses that recognize the value of sports-driven engagement and visibility.<br/><br/>
Whether you aim to elevate your brand, co-sponsor exclusive pools, or host tailored fundraising events, we deliver a strategic game plan customized to your goals.
                    </Typography>
                </Box>
                <Box sx={{
                   maxWidth: isMobile? "300px" : "375px",
                  margin: isMobile? "16px auto" : "unset"
                }}>
                  <Typography
                    sx={{
                      color: "var(--color-black)",
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "18px",
                      lineHeight: "150%",
                      letterSpacing: "-0.266px",
                      textAlign: "left", // Ensure the text is aligned to the left
                    }}>
                      Tiered Partnerships
                    </Typography>
                    <Typography sx={{
                      textAlign: "left", // Ensure the text is aligned to the left
                      lineHeight: "150%",
                      fontSize: "16px", // Ensure the font size is consistent
                    }}>
                    Whether you want to reach the entire town or connect more deeply with your existing community, we offer opportunities tailored to your ambitions.<br/><br/>

From larger Sitewide Main Events to targeted Community Pools, we’ve got the perfect fit for your needs.<br/><br/>

Amplify your brand by aligning with our exclusive sports pools, with your business showcased across promotional materials, social media campaigns, and digital platforms.<br/><br/>

Engagement, competition, and action - that’s the essence of sports pool.<br/><br/>
                    </Typography>
                </Box>

              </Box>
              <Button
               onClick={() => handleScrollTo("contactForm")}
              sx={{
                  backgroundColor: "#07356B",
                  color: "#FFFFFF",
                  width: "130px",
                  display: 'block',
                  margin: '20px auto', // Center the button horizontally
                  "&:hover": {
                    backgroundColor: "#07356B !important"
                  },
              }}>
                Contact Us
              </Button>
              {/* Region Start -- A pool is born */}
              <Box sx={{background: "#07356B", color: "#FFFFFF", paddingTop: "32px", paddingBottom:'32px'}}>
                <Typography
                  sx={{
                    color: "var(--color-white)",
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: isMobile? "40px" : "56px",
                    lineHeight: "150%",
                    letterSpacing: "-0.266px",
                    textAlign: "center",
                  }}
                  variant="h2">
                    A Pool is born
                  </Typography>
                  <Typography sx={{
                    color: "var(--color-white)",
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "18px", // Adjusted for better readability
                    lineHeight: "170%",
                    letterSpacing: "-0.266px",
                    textAlign: "center",
                    padding: "16px 16px 0", // Padding for spacing above the text
                    maxWidth: "850px", // Limit the width for better readability
                    margin: "0 auto",
                  }}>
                  Sports bring people together, and we help turn that energy into impact. Whether you're a fundraising group, a local business, or an organization looking to creatively market, our platform allows you to host customized pools that benefit your cause, while delivering a memorable community experience.
                  </Typography>
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between', // Adjust to space-between for even distribution
                    alignItems: 'center', // Align items vertically in the center
                    padding: '32px 16px', // Add padding for better spacing
                    gap: 4, // Add some space between the boxes
                    flexDirection: { xs: 'column', sm: 'row' }, // Stack on small screens
                  }}>
                    <Box sx={{
                      flex:1,
                      textAlign: "left",
                      width: { xs: "100%", lg: "100%" },
                      margin: "0 0 0 auto",
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                      maxWidth: "460px",
                    }}>
                      <img src="https://poolpartyfilestorage.blob.core.windows.net/media/featureGameCard.png" alt="" />
                    </Box>
                    <Box sx={{
                      textAlign: "left", // Ensure the text is aligned to the left
                      flex:1,
                      width: { xs: "100%", lg: "100%" },
                      margin: isMobile? "0 auto" : "0 auto 0 0",
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                      maxWidth: "300px",
                    }}>
                      <Typography sx={{
                        color: "var(--color-white)",
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: "22px",
                        lineHeight: "150%",
                        letterSpacing: "-0.266px",
                      }}>Designed to stand out</Typography>
                      <Typography>Together we can show your customers what it means to be a caring and creative organization. Our custom built pools offer additional benefits such as customer retention, enhanced social media engagement, and opportunities for exclusive promotions and giveaways. <br/><br/>With seamless integration into your marketing plan, our pools provide a dynamic way to strengthen your brand's presence, while giving your audience a unique way to celebrate.</Typography></Box>
                  </Box>
              </Box>
              {/* Region End -- A pool is born */}
              {/* #REGION START -- Success stories */}
              <Box
              sx={{
                width: { xs: "100%", lg: "100%" },
                margin: "auto",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                // px: 3,
              }}
            >
              <Typography
                sx={{
                  color: "var(--color-black)",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "800",
                  fontSize: isMobile? "40px" : "58px",
                  lineHeight: "150%",
                  letterSpacing: "-0.87px",
                  textAlign: "center",
                }}
                variant="h1"
              >
                Success stories
              </Typography>
              <Typography
                sx={{
                  color: "var(--color-text)",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "16px",
                  lineHeight: "170%",
                  letterSpacing: "-0.266px",
                  maxWidth: isMobile? "300px" : "822px",
                  margin: "0 auto",
                }}
                variant="body1"
              >
Each new partnership is like the beginning of a story. We strive to celebrate the world of sports through fun and engaging sports pools, on a platform that everyone can use. Hear what our partners have to say about us!
 </Typography>
              <Box sx={{
                display: isMobile? 'block' : 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start', // Align items to the start of the flex container
                gap: 5, // Add some space between the boxes
              }}>
                <Box sx={{
                  maxWidth: isMobile? "300px" : "375px",
                  margin: isMobile? "16px auto" : "unset"
                }}>
                    <img style={{display:'block'}} src="https://poolpartyfilestorage.blob.core.windows.net/media/DAVIDALLENLOGONEW.png" alt="" />
                  <Typography
                    sx={{
                      color: "var(--color-black)",
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "18px",
                      lineHeight: "150%",
                      letterSpacing: "-0.266px",
                      textAlign: "left", // Ensure the text is aligned to the left
                    }}>
                      David Alan Clothing
                    </Typography>
                    <Typography sx={{
                      textAlign: "left", // Ensure the text is aligned to the left
                      lineHeight: "150%",
                      fontSize: "16px", // Ensure the font size is consistent
                    }}>
                    David Alan Clothing is a rock star in the fashion and sports arenas, bridging iconic leagues like the NFL, NHL, MLB, WWE, you name it.<br /><br />

The Super Bowl Pool was an ideal match - the grandest, most sophisticated event of the year. It captures attend from every angle: pre-game hype, halftime thrills, standout commercials, and the game itself. We covered it all, ensuring every moment counts.<br /><br />

Not to be overshadowed by David Alan Clothing's Super Bowl Commercial, but the pool was a success in what ended up being a dominating win for the Philadelphia Eagles over the rundown Kansas City Chiefs. Our pool winner ended up winning the suit for his soon to be brother-in-law in an incredible wedding story.<br /><br />

Let's not forget about second and third place who went home with some style. And we cannot wait to be back next year for Super Bowl LX for an even bigger competition.<br /><br />
                    </Typography>
                </Box>
                <Box sx={{
                 maxWidth: isMobile? "300px" : "375px",
                  margin: isMobile? "16px auto" : "unset"
                }}>
                  <img style={{display:'block'}} src="https://poolpartyfilestorage.blob.core.windows.net/media/mikeAndTonysHorizontalLogo.webp" alt="" />
                  <Typography
                    sx={{
                      color: "var(--color-black)",
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "18px",
                      lineHeight: "150%",
                      letterSpacing: "-0.266px",
                      textAlign: "left", // Ensure the text is aligned to the left
                    }}>
                      Why join our winning team?
                    </Typography>
                    <Typography sx={{
                      textAlign: "left", // Ensure the text is aligned to the left
                      lineHeight: "150%",
                      fontSize: "16px", // Ensure the font size is consistent
                    }}>
                    Mike & Tony's Gyro was the one that started it all. They had no reason to say yes. But they did. And The Mike & Tony's Gyros NFL 2nd Shot Survivor Pool was born. This paved the way for all of our partnered pools.<br /><br />

Beyond the 2nd Shot Survivor, Pool Party has hosted a Final Four Watch Party, a Steelers Watch Party ft. a Prop Pool, and a Beer Pong Madness Tournament at M&T's locations. More where that came from.<br /><br />

M&T's will continue to be a pioneer in the sports pool landscape and have great pride in their sports pool prowess.<br /><br />
                    </Typography>
                </Box>

              </Box>
              <Button sx={{
                  backgroundColor: "#07356B",
                  color: "#FFFFFF",
                  width: "130px",
                  display: 'block',
                  margin: '20px auto', // Center the button horizontally
                  minWidth: "130px",
                  "&:hover": {
                    backgroundColor: "#07356B !important"
                  },
              }}>
                Contact Us
              </Button>
              </Box>
              {/* #REGION END -- Success stories */}
              {/* Form Region -- Start */}
              <Typography  sx={{
                  color: "var(--color-black)",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "800",
                  fontSize:"58px",
                  lineHeight: "150%",
                  letterSpacing: "-0.87px",
                  textAlign: "center",
                }}
                variant="h2">
                Get connected
              </Typography>
              <Typography sx={{textAlign:'center'}}>
                Interested in taking the next step with us? Complete and submit this form to get the process started.
              </Typography>
              <img style={{
                width: "100%",
                height: "auto",
                marginBottom: 20,
                display: 'block',
                margin: '0 auto',
                maxWidth: isMobile? "300px" : "845px"
              }} src="https://poolpartyfilestorage.blob.core.windows.net/media/gamePlaysImage.png" alt=''/>
              <Box
                id="contactForm"
                sx={{
                  width: { xs: "80%", sm: "60%" },
                  margin: "auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: "1.2rem",
                  pt: 2,
                }}
              >
                <TextField
                  id="fullName"
                  name="fullName"
                  label="Full Name"
                  variant="outlined"
                  type="text"
                  value={contactDetails.fullName}
                  error={contactValidationDetails.fullName.isError}
                  helperText={contactValidationDetails.fullName.message}
                  onInput={onContactDetailsChange}
                  required
                />
                <TextField
                  id="email"
                  name="email"
                  label="Email address"
                  variant="outlined"
                  type="email"
                  value={contactDetails.email}
                  error={contactValidationDetails.email.isError}
                  helperText={contactValidationDetails.email.message}
                  onInput={onContactDetailsChange}
                  required
                />

                <FormControl
                  fullWidth
                  error={contactValidationDetails.contactType.isError}
                  required
                >
                  <InputLabel id="contactType-label">Business Type</InputLabel>
                  <Select
                    labelId="contactType-label"
                    id="contactTypeOptions"
                    name="contactType"
                    value={contactDetails.contactType}
                    onChange={onContactDetailsChange}
                    sx={{
                      ".MuiSelect-select": {
                        // This targets the internal <div> element that holds the selected value
                        textAlign: "left",
                        alignItems: "center", // Ensures vertical centering if needed
                      },
                    }}
                    label="Business Type" // This is necessary for proper accessibility and label floating
                  >

                    <MenuItem value={"Fundraiser"}>Fundraiser</MenuItem>
                    <MenuItem value={"Restaurant"}>Bar / Restaurant</MenuItem>
                    <MenuItem value={"Business"}>Business</MenuItem>
                    <MenuItem value={"Creator"}>Creator</MenuItem>
                  </Select>
                  {contactValidationDetails.contactType.isError && (
                    <Typography color="error" variant="caption" className="block text-left pl-4 pt-1" >
                      {contactValidationDetails.contactType.message}
                    </Typography>
                  )}
                </FormControl>
                <TextField
                  id="company"
                  name="company"
                  label="Company"
                  variant="outlined"
                  type="company"
                  value={contactDetails.company}
                  error={contactValidationDetails.company.isError}
                  helperText={contactValidationDetails.company.message}
                  onInput={onContactDetailsChange}
                  required
                />
                <TextField
                  id="message"
                  name="message"
                  label="Message"
                  multiline
                  rows={4}
                  inputProps={{
                    maxLength: MESSAGE_CHARACTERS_LIMIT, // Setting maximum character length
                  }}
                  value={contactDetails.message}
                  error={contactValidationDetails.message.isError}
                  helperText={contactValidationDetails.message.message}
                  onInput={onContactDetailsChange}
                  required
                />
                {/* width: "16%", minWidth: "6rem", mt: 3,  */}
                <Button
                  variant="contained"
                  sx={{  backgroundColor: "#07356B",
                    color: "#FFFFFF",
                    width: "130px",
                    display: 'block',
                    margin: '20px auto', // Center the button horizontally
                    minWidth: "130px",
                    "&:hover": {
                      backgroundColor: "#07356B !important"
                    }, }}
                  onClick={onSubmit}
                >
                  Submit
                </Button>
              </Box>
              {/* Form Region -- End */}

            </Box>
          </>
        )}
         <Box sx={{
                paddingTop: '32px',
                paddingBottom: '32px',
                backgroundImage:'url(https://poolpartyfilestorage.blob.core.windows.net/media/champ-belt-cut.png)',
                backgroundPosition: '0 20%',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                height: isMobile ? 'unset' : '230px'
              }}>
                  <Box sx={{
                     width: isMobile? '90%' : '100%',
                     margin: '0 auto',
                }}>
                <Box sx={{
                  maxWidth: '1295px',
                  margin: '0 auto',
                  padding: '32px 0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: isMobile? 'column' : 'row',
                  flexFlow: isMobile? 'column' : 'row',
                }}>
                  <Box
                    sx={{
                      maxWidth:'535px'
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '44px',
                        fontWeight: 800,
                        color: '#FFFFFF',
                        textAlign: 'left',
                        textShadow: '1px 1px 10px #222'
                      }}
                    >
                    {/* Start playing today */}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '16px',
                        fontWeight: 500,
                        color: '#FFFFFF',
                        textAlign: 'left',
                        marginBottom: '32px',
                        textShadow: '1px 1px 8px #111'

                      }}>
                      {/* Pool Party Gaming wants you! Signing up is easy, so that you can get playing in minutes! Start by entering in your email address. */}
                    </Typography>
                  </Box>
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '16px',
                    marginBottom: '32px',
                    flexDirection: isMobile? 'column' : 'row',
                    flexFlow: isMobile? 'column' : 'row',
                  }}>
                    {/* <TextField
                      sx={{ width: '300px', backgroundColor: '#FFFFFF',
                        border:'1px solid #C1C1C1',
                        borderRadius: '8px' }}
                      label="Your Email"
                      variant="filled"
                    /> */}
                    {/* <Button variant="contained" sx={{
                      background: '#FFC60A',
                      color:'#1C1C1C',
                      width:'300px'
                    }}
                    onClick={() => {handleRegURL('register')}}
                    >
                      Sign Up
                    </Button> */}
                  </Box>
                  </Box>
                </Box>
              </Box>
      </Box>
    </>
  );
}
